import * as Data from "@/../src-gen/data";
import FFormSubmitBtnMDP from "@/components/FFormSubmitBtnMDP";
import FFormDrawerMDP from "@/components/form/FFormDrawerMDP";
import { FFormChildMDP } from "@/components/form/FFormMDP";
import FSelectDateFieldMDP from "@/components/form/field/FDateSelectFieldMDP";
import FGompaUserRemoteAutoCompleteFieldMDP from "@/components/form/field/FGompaUserRemoteAutoCompleteMDP";
import FSelectFieldMDP from "@/components/form/field/FSelectFieldMDP";
import FTextFieldMDP from "@/components/form/field/FTextFieldMDP";


export default class LeadDumpQstnAskdFFormMDP extends FFormDrawerMDP {
    parent: any;
    childMDP = new FFormChildMDP();

    constructor({isVisible, onClose, parent}: {isVisible: boolean, onClose: () => void, parent: any}) {
        super({
            myRefName: "leadDumpQstnAskdFFormRef",
            title: "Request Lead Dump",
            isVisible,
            onClose, 
        })

        this.parent = parent;

        this.addField(
            new FSelectDateFieldMDP({
                parentMDP: this.childMDP,
                dataSelectorKey: "fromDate",
                label: "From Date",
                boundaryClass: "col-12",
                mandatory: true,
            })
        )
        .addField(
            new FSelectDateFieldMDP({
                parentMDP: this.childMDP,
                dataSelectorKey: "toDate",
                label: "To Date",
                boundaryClass: "col-12",
                mandatory: true,
            })
        )
        .addField(
            new FSelectFieldMDP({
                parentMDP: this.childMDP,
                options: [Data.Insight.QUESTION_CODE.DSADUMPREQUEST],
                dataSelectorKey: "questionCode",
                label: "Question Code",
                boundaryClass: "col-12",
                optionLabel: "name",
                optionValue: "id",
                returnObject: true
            })
        )
        .addField(
            new FTextFieldMDP({
                parentMDP: this.childMDP, 
                dataSelectorKey: "questionName",
                label: "Question Name",
                boundaryClass: "col-12"
            })
        )
        .addField(
            new FGompaUserRemoteAutoCompleteFieldMDP({
                parentMDP: this.childMDP,
                dataSelectorKey: "emailSubscriberName",
                label: "Email Subscriber Name",
                boundaryClass: "col-12",
                smallChips: true,
                clearable: false,
                mandatory: true,
                multiple: true
            })
        )
        .addAction(
            new FFormSubmitBtnMDP({
                label: "Submit",
                onClick: this.parent.dumpReqQuestionAsked,
            })
        )
    }

    getMyRef() {
        return this.parent.$refs[this.myRefName];
    }

}